import { render, staticRenderFns } from "./ReviewBankcard.vue?vue&type=template&id=c9817438"
import script from "./ReviewBankcard.vue?vue&type=script&lang=js"
export * from "./ReviewBankcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports